import React, {Component} from 'react';
import {connect} from "react-redux";
import {getCamelCaseType} from "../WheelsExchangeUtils";
import {Col, List, Row} from "antd";
import Constants from "../../../services/Constants";
import moment from 'moment';
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

class SwitchPlanningSlots extends Component {

  constructor(props) {
    super(props);
    this.state = {
      slots: [],
      selectedIndex: props.index || undefined,
      customer: null,
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.fetchWheelsExchangeSlots) {
      const hasError = nextProps.fetchWheelsExchangeSlots.error && nextProps.fetchWheelsExchangeSlots.error.code;
      this.setState({slots: hasError ? [] : nextProps.fetchWheelsExchangeSlots.slots})
    }
    if (nextProps.day) {
      this.setState({selectedIndex: null});
      nextProps.onUpdate(null);
    }
  }

  slotIsAvailable = slot => {
    return slot.customers && slot.customers.length < slot.numberOfTeams;
  };

  onChangeSlot = (index, slot) => {
    const {selectedIndex} = this.state;
    const {onUpdate, day} = this.props;
    if (selectedIndex === index && day === this.state.day) {
      this.setState({selectedIndex: null, day: null, slot: null});
      onUpdate(null);
    } else {
      this.setState({selectedIndex: index, day, slot});
      onUpdate(slot);
    }
  }

  onAddHereHandler = (slot) => {
    const {onUpdate} = this.props;
    onUpdate(slot);
  }

  render() {
    const {selectedIndex} = this.state;
    const {day, fetchSwitchExchangeWheelsSlots: {loading, slots}} = this.props;

    return (
      <div style={{height: '56rem', overflow: 'auto', border: '1px solid #e6e6e6'}}>
        <List className="list" dataSource={slots} loading={loading}
              renderItem={(item, index) => {
                const {customers = [], numberOfTeams, startTime, endTime} = item;
                return (
                  <List.Item style={{border: '1px solid #e6e6e6'}} onClick={() => this.onChangeSlot(index, item)}>
                    <Row justify={"space-between"} style={{width: '100%'}}>

                      <Col span={4} style={{textAlign: 'center'}}>
                        <span className={`badge ${this.slotIsAvailable(item) ? 'calendar-box--available' : 'calendar-box--unavailable'}`}>{customers.length} / {numberOfTeams}
                        </span>
                      </Col>

                      <Col span={4} style={{textAlign: 'center'}}>
                        {moment(startTime, Constants.TIME_FORMAT_API).format(Constants.TIME_FORMAT_DISPLAY)}{` - `}
                        {moment(endTime, Constants.TIME_FORMAT_API).format(Constants.TIME_FORMAT_DISPLAY)}
                      </Col>

                      <Col span={4} style={{textAlign: 'center'}}>
                        {this.slotIsAvailable(item) &&
                          <button
                            type="primary"
                            className={`btn btn-sm ${selectedIndex === index && day === this.state.day ? 'ant-btn-disabled' : 'btn-primary'}`}
                            onClick={() => this.onAddHereHandler(item)}
                          >
                            <FormattedMessage id={selectedIndex === index && day === this.state.day ? 'action.added' : 'action.add'}/>
                          </button>
                        }
                      </Col>
                    </Row>
                  </List.Item>
                )
              }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const fetchSwitchExchangeWheelsSlots = state['fetchSwitchExchangeWheelsSlots'];
  const updateWheelsExchangeSlots = state[`update${camelCaseType}ExchangeCustomers`];
  const switchTiresWheelsSlots = state['switchTiresWheelsSlots'];
  return {fetchSwitchExchangeWheelsSlots, updateWheelsExchangeSlots, switchTiresWheelsSlots}
};

export default withRouter(connect(mapStateToProps)(SwitchPlanningSlots));
